import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

document.title = "Authentication";

createApp(App).use(router).mount("#app");
